// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lr-repair-box {
    padding: 60px;
    border: solid 1px #cbcbcb;
    position: relative;
}
.lr-repair-box .-oneX-icon-container {
    position: absolute;
    top: 60px;
    right: 60px;
}
.lr-repair-box h3 {
    padding-right: 50px;
    margin-bottom: 28px;
}
.lr-repair-box p {
    margin-bottom: 0;
}
.lr-disclaimer {
    margin-top: 35px;
}
.lr-submit {
    margin-top: 35px;
    margin-bottom: 50px;
}
.lr-review-answer {
    padding: 0px;
    position: relative;
}

@media(max-width: 540px) {
    .lr-repair-box h3 {
        margin-bottom: 12px;
    }
    .lr-repair-box p {
        padding-right: 50px;
    }
    .vehicle-spacing,.vehicle-spacing-2ndvehicle {
        display: none;
    }
}

.lr-answer-smaller {
    font-size: 12px;
}

.lr-answer-otherVehicles {
    font-size: 20px;
}

.padding-right-claimaintInfo {
    padding-right: 10px;
}

.vehicle-spacing{
    width: 10%;
    float: left;
    height: 40px;
}

.vehicle2-spacing{
    padding-left: 9px;
    padding-top: 7px;
}

.vehicle-spacing-2ndvehicle{
    width: 10%;
    float: left;
    height: 43px;
}

.otherVehicles-spacing{
    padding-bottom: 8px;
}

.gray-circle{
    width: 40px;
    height: 40px;
    background-color: #F3F3F3;
    border-radius: 50%;
}

.olr-icon-car_review_submit {
    background-image: url('icon_car_review_submit.svg');
    width: 24px;
    height: 20px;
    background-repeat: no-repeat;
    background-size: contain;
    display: block;
}

.lr-inner-card {
  padding-left: 0px;
}

.lr-list {
  padding-left: 0;
  margin-bottom: 34px;
}
.lr-list li {
  list-style: none;
  margin-bottom: 8px;
}
.lr-list li img{
  padding-right: 10px;
}

.checkmark{
background-image: url('icon-checkmark.svg');
width: 24px;
height: 20px;
background-repeat: no-repeat;
background-size: contain;
display: -webkit-inline-box;
}

@media(min-width: 768px) {
  .lr-list {
      margin-bottom: 56px;
  }
}

@media(min-width: 1200px) {
  .lr-list {
      margin-bottom: 34px;
  }
}

.photo-grid{
    display: grid;
    grid-template-columns: repeat(3,1fr);
    gap: 5px;
    width: 345px;
}

.preview-photo-box{
    display: flex;
    width: 120px;
    height: 68.09px;
    object-fit: cover;
}
.preview-photo-box2{
  display: flex;
  width: 120px;
  height: 68.09px;
  object-fit: cover;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #F7F0E4;
}
.upload-text{
  max-width: 120px;
  text-align: center;
  font-family: "Mecherle Sans";
  color: #4a4a4a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display:inline-block;
  vertical-align: bottom;;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.preview-photo-box-stock{
  display: flex;
  width: 120px;
  height: 68.09px;
  object-fit: cover;
  background-color: #F7F0E4;
  gap:4px;
}
.upload-img{
  background-image: url(/assets/img/image_32px.svg);
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color:#4a4a4a;
  background-color: #F7F0E4;
}

.upload-text{
  max-width: 107.75px;
  text-align: center;
  font-family: "Mecherle Sans";
  color: #4a4a4a;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  display:inline-block;
  vertical-align: bottom;;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
`, "",{"version":3,"sources":["webpack://./projects/lossreporting-library/src/lib/review/review-claim/review-claim.component.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,mDAAqE;IACrE,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,wBAAwB;IACxB,cAAc;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;;AAEA;AACA,2CAA6D;AAC7D,WAAW;AACX,YAAY;AACZ,4BAA4B;AAC5B,wBAAwB;AACxB,2BAA2B;AAC3B;;AAEA;EACE;MACI,mBAAmB;EACvB;AACF;;AAEA;EACE;MACI,mBAAmB;EACvB;AACF;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;IACf,iBAAiB;AACrB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,OAAO;AACT;AACA;EACE,iDAAiD;EACjD,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB","sourcesContent":[".lr-repair-box {\n    padding: 60px;\n    border: solid 1px #cbcbcb;\n    position: relative;\n}\n.lr-repair-box .-oneX-icon-container {\n    position: absolute;\n    top: 60px;\n    right: 60px;\n}\n.lr-repair-box h3 {\n    padding-right: 50px;\n    margin-bottom: 28px;\n}\n.lr-repair-box p {\n    margin-bottom: 0;\n}\n.lr-disclaimer {\n    margin-top: 35px;\n}\n.lr-submit {\n    margin-top: 35px;\n    margin-bottom: 50px;\n}\n.lr-review-answer {\n    padding: 0px;\n    position: relative;\n}\n\n@media(max-width: 540px) {\n    .lr-repair-box h3 {\n        margin-bottom: 12px;\n    }\n    .lr-repair-box p {\n        padding-right: 50px;\n    }\n    .vehicle-spacing,.vehicle-spacing-2ndvehicle {\n        display: none;\n    }\n}\n\n.lr-answer-smaller {\n    font-size: 12px;\n}\n\n.lr-answer-otherVehicles {\n    font-size: 20px;\n}\n\n.padding-right-claimaintInfo {\n    padding-right: 10px;\n}\n\n.vehicle-spacing{\n    width: 10%;\n    float: left;\n    height: 40px;\n}\n\n.vehicle2-spacing{\n    padding-left: 9px;\n    padding-top: 7px;\n}\n\n.vehicle-spacing-2ndvehicle{\n    width: 10%;\n    float: left;\n    height: 43px;\n}\n\n.otherVehicles-spacing{\n    padding-bottom: 8px;\n}\n\n.gray-circle{\n    width: 40px;\n    height: 40px;\n    background-color: #F3F3F3;\n    border-radius: 50%;\n}\n\n.olr-icon-car_review_submit {\n    background-image: url(../../../assets/img/icon_car_review_submit.svg);\n    width: 24px;\n    height: 20px;\n    background-repeat: no-repeat;\n    background-size: contain;\n    display: block;\n}\n\n.lr-inner-card {\n  padding-left: 0px;\n}\n\n.lr-list {\n  padding-left: 0;\n  margin-bottom: 34px;\n}\n.lr-list li {\n  list-style: none;\n  margin-bottom: 8px;\n}\n.lr-list li img{\n  padding-right: 10px;\n}\n\n.checkmark{\nbackground-image: url(../../../assets/img/icon-checkmark.svg);\nwidth: 24px;\nheight: 20px;\nbackground-repeat: no-repeat;\nbackground-size: contain;\ndisplay: -webkit-inline-box;\n}\n\n@media(min-width: 768px) {\n  .lr-list {\n      margin-bottom: 56px;\n  }\n}\n\n@media(min-width: 1200px) {\n  .lr-list {\n      margin-bottom: 34px;\n  }\n}\n\n.photo-grid{\n    display: grid;\n    grid-template-columns: repeat(3,1fr);\n    gap: 5px;\n    width: 345px;\n}\n\n.preview-photo-box{\n    display: flex;\n    width: 120px;\n    height: 68.09px;\n    object-fit: cover;\n}\n.preview-photo-box2{\n  display: flex;\n  width: 120px;\n  height: 68.09px;\n  object-fit: cover;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background-color: #F7F0E4;\n}\n.upload-text{\n  max-width: 120px;\n  text-align: center;\n  font-family: \"Mecherle Sans\";\n  color: #4a4a4a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  display:inline-block;\n  vertical-align: bottom;;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.preview-photo-box-stock{\n  display: flex;\n  width: 120px;\n  height: 68.09px;\n  object-fit: cover;\n  background-color: #F7F0E4;\n  gap:4px;\n}\n.upload-img{\n  background-image: url(/assets/img/image_32px.svg);\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  color:#4a4a4a;\n  background-color: #F7F0E4;\n}\n\n.upload-text{\n  max-width: 107.75px;\n  text-align: center;\n  font-family: \"Mecherle Sans\";\n  color: #4a4a4a;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n  display:inline-block;\n  vertical-align: bottom;;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
